import React, { useEffect, useState } from 'react';
import {
  Select,
  MenuItem,
  Modal,
  Card,
  Box,
  label,
  div,
  Button,
  TextField,
  ThemeProvider,
} from '../MaterialUI/index';
import { useStyles, Theme } from './ContactUsStyle.js';
import { useSelector, useDispatch } from 'react-redux';
import { contact, contactUs } from '../../Action/action';
import closeBtn from '../../assets/images/closeBtn.png';
import Autocomplete from '@mui/material/Autocomplete';
import BackToHome from '../UI/BackToHome/BackToHome';
import PhoneField from '../UI/PhoneField/PhoneField';
import { CountryList } from '../../Utils/CountryList';

export default function SimpleModal(props) {
  const dispatch = useDispatch();

  const classes = useStyles();
  const [contactPlan, setPlan] = useState('');
  const [contactValue, setValue] = useState('');

  const [formData, setFormData] = React.useState({
    firstname: '',
    lastname: '',
    company: '',
    phone: '',
    country: '',
    email: '',
    designation: '',
    brandProductName: '',
    interestedIn: '',
    message: '',
    monthlyBudget: '',
  });

  useEffect(() => {
    setFormData({ ...formData, phone: props.profile && props.profile.phone });
  }, [props.profile]);

  useEffect(() => {
    if (props.plan === undefined) {
      setPlan('enterprise');
      setValue(false);
    } else {
      setPlan('plan');
      setValue(props.plan);
    }
  }, [props.plan]);

  const handleSubmit = (e) => {
    const key = contactPlan;
    e.preventDefault();
    const body = {
      ...formData,
      firstname: props.profile.firstName,
      lastname: props.profile.lastName,
      email: props.profile.email,
      [key]: contactValue,
    };
    dispatch(contact(body));
    dispatch(contactUs(false, 'open contact', false));
    setFormData({});
  };

  const posts = useSelector((state) => state);

  const handleClose = () => {
    dispatch(contactUs(false, 'open contact'));
  };

  const countries = () => {
    return Country.getAllCountries();
  };

  const body = (
    <ThemeProvider theme={Theme}>
      <Card
        style={{ display: 'block', border: 'none', marginTop: '2%' }}
        boxShadow={2}
        className={classes.card}
        variant="outlined"
      >
        <div className={classes.cardTitle}>
          <div style={{ padding: '28px 0 0 32px', color: 'white' }}>Give us a shout</div>
          <img onClick={handleClose} className={classes.CloseProduct} src={closeBtn} />
        </div>
        <div className={classes.paper}>
          <div style={{ width: '100%' }}></div>
          <form className={classes.form} noValidate>
            <div className={classes.mainSideContact}>
              <div className={classes.leftSideContact}>
                <div style={{ display: 'flex', marginTop: '32px' }}>
                  <div className={classes.ContactInput}>
                    {' '}
                    <label className={classes.Label1}>First name</label>
                    <input
                      style={{ marginRight: '24px', width: '90%' }}
                      type="text"
                      required
                      disabled
                      value={props.profile.firstName}
                      onChange={(event) =>
                        setFormData({ ...formData, firstname: event.target.value })
                      }
                    // error={emailid !== ""}
                    />
                  </div>
                  <div className={classes.ContactInput}>
                    <label className={classes.Label1}>Last name</label>
                    <input
                      type="text"
                      style={{ width: '100%' }}
                      required
                      disabled
                      value={props.profile.lastname}
                      onChange={(event) =>
                        setFormData({ ...formData, lastname: event.target.value })
                      }
                    // error={emailid !== ""}
                    />
                  </div>
                </div>
                <div className={classes.ContactInput}>
                  <label className={classes.Label1}>Work email</label>
                  <input
                    type="text"
                    required
                    disabled
                    value={props.profile.email}
                    onChange={(event) =>
                      setFormData({ ...formData, email: event.target.value })
                    }
                  // error={emailid !== ""}
                  />
                </div>
                <div className={classes.ContactInput}>
                  <label className={classes.Label1}>Phone number</label>
                  {/* <input
                    type="number"
                    value={formData.phone}
                    required
                    onChange={(event) =>
                      setFormData({ ...formData, phone: event.target.value })
                    }
                    // error={emailid !== ""}
                  /> */}
                  <PhoneField
                    value={(formData.phone && formData.phone) || props.profile.phone}
                    name="phone"
                    /** TO BE UNCOMMENTED IF REQUIRES COUNTRY ACC TO USER'S LOCATION **/
                    // country={true}
                    setValue={(phone) => setFormData({ ...formData, phone })}
                  />
                </div>
                <div className={classes.ContactInput}>
                  <label className={classes.Label1}>Designation</label>
                  <input
                    type="text"
                    required
                    value={formData.designation}
                    onChange={(event) =>
                      setFormData({ ...formData, designation: event.target.value })
                    }
                  // error={emailid !== ""}
                  />
                </div>
                <div className={classes.ContactInput}>
                  <label className={classes.Label1}>Company name</label>
                  <input
                    type="text"
                    required
                    value={formData.company}
                    onChange={(event) =>
                      setFormData({ ...formData, company: event.target.value })
                    }
                  // error={emailid !== ""}
                  />
                </div>
                <div className={classes.ContactInput}>
                  <label className={classes.Label1}>Your brand/product name</label>
                  <input
                    type="text"
                    required
                    value={formData.brandProductName}
                    onChange={(event) =>
                      setFormData({ ...formData, brandProductName: event.target.value })
                    }
                  // error={emailid !== ""}
                  />
                </div>
                <div className={classes.ContactInput}>
                  <label className={classes.Label1}>Your monthly budget(USD)</label>
                  <input
                    type="number"
                    required
                    value={formData.monthlyBudget}
                    onChange={(event) =>
                      setFormData({ ...formData, monthlyBudget: event.target.value })
                    }
                  // error={emailid !== ""}
                  />
                </div>
                <div className={classes.ContactInput} value={formData.interestedIn}>
                  <label className={classes.Label2} shrink={false}>
                    Choose ReBid product
                  </label>
                  <TextField
                    variant="outlined"
                    size="small"
                    SelectProps={{
                      MenuProps: {
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                      },
                    }}
                    select
                    margin="normal"
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    onChange={(event) =>
                      setFormData({ ...formData, interestedIn: event.target.value })
                    }
                    fullWidth
                  >
                    <MenuItem className={classes.selectOption} value={'ReBid ADP'}>
                      ReBid ADP
                    </MenuItem>
                    <MenuItem className={classes.selectOption} value={'ReBid CDP'}>
                      ReBid CDP
                    </MenuItem>
                  </TextField>
                </div>
                <div className={classes.ContactInput} size="small" variant="outlined">
                  <label
                    className={classes.Label2}
                    shrink={false}
                    id="demo-simple-select-outlined-label"
                  >
                    Country or region
                  </label>
                  <Autocomplete
                    options={CountryList}
                    onChange={(event, newValue) => {
                      setFormData({ ...formData, country: newValue.name });
                    }}
                    disablePortal
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option) => (
                      <Box
                        style={{ height: '40px' }}
                        component="li"
                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        <img
                          loading="lazy"
                          width="20"
                          src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                          srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                          alt=""
                          style={{ marginRight: '8px' }}
                        />
                        {option.name}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        variant="outlined"
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password',
                        }}
                      />
                    )}
                  />
                </div>
              </div>
            </div>
            <div className={classes.ContactInput}>
              <label className={classes.Label1}>Message (Optional)</label>
              <input
                type="text"
                value={formData.message}
                style={{
                  width: '-webkit-fill-available',
                  height: '80px',
                  marginBottom: '2rem',
                }}
                onChange={(event) =>
                  setFormData({ ...formData, message: event.target.value })
                }
              // error={emailid !== ""}
              />
            </div>

            <div style={{ marginTop: '-35px' }}>
              <BackToHome
                active={
                  formData.phone &&
                  formData.designation &&
                  formData.company &&
                  formData.brandProductName &&
                  formData.monthlyBudget &&
                  formData.country
                }
                title="Submit"
                action={handleSubmit}
                width="100%"
              />
            </div>
            <div style={{ margin: '5% 2%', fontSize: '0.875rem', color: '#17191d' }}>
              <p>
                On clicking submit, you are agreeing to our website’s terms & conditions &
                privacy policy
              </p>
            </div>
          </form>
        </div>
      </Card>
    </ThemeProvider>
  );

  return (
    <div>
      <Modal
        open={posts.menuReducer.openContact}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
